import i18n from "@/locales"
const $t = i18n.global.t
const MenuList = [
    {
        name: $t("l_Order_search"),
        icon: "travel_explore",
        routerPath: "/admin/search/all",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Order_search") + " (JPID)",
        icon: "group",
        routerPath: "/admin/search/user-all-order",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Registered_user"),
        icon: "group",
        routerPath: "/admin/user",
        expand: false,
        children: [],
        isSuper: false,
    },
    {
        name: $t("l_Recipient"),
        icon: "badge",
        routerPath: "/admin/ship",
        expand: false,
        children: [],
        isSuper: false,
    },
    {
        name: $t("l_Statistic"),
        icon: "analytics",
        routerPath: "/admin/batch/statistics",
        expand: false,
        children: [],
        isSuper: false,
    },
    {
        name: $t("l_Promocode"),
        icon: "loyalty",
        routerPath: "/admin/referral-promo",
        expand: false,
        children: [],
        isSuper: false,
    },
    {
        name: $t("l_Branch_statistic"),
        icon: "analytics",
        routerPath: "/admin/branch/statistics",
        expand: false,
        children: [],
        isSuper: false,
    },
    {
        name: $t("l_Complaints"),
        icon: "feedback",
        routerPath: "_232",
        expand: true,
        children: [
            {
                name: $t("l_Payment_complaint"),
                icon: "quiz",
                routerPath: "/admin/feedback",
                expand: true,
                children: [],
            },
            {
                name: $t("l_Reason"),
                routerPath: "/admin/feedback/reason-status/list",
                expand: true,
                icon: "feedback",
                permissionTag: "__",
                children: [],
            },
            {
                name: $t("l_Result"),
                routerPath: "/admin/feedback/result-status/list",
                expand: true,
                icon: "feedback",
                permissionTag: "__",
                children: [],
            },
            {
                name: $t("l_Refund_account"),
                routerPath: "/admin/feedback/refound-account/list",
                expand: true,
                icon: "feedback",
                permissionTag: "__",
                children: [],
            },
            {
                name: $t("l_Burned"),
                routerPath: "/admin/feedback/burned-orders/list",
                expand: false,
                icon: "feedback",
                permissionTag: "__",
                children: [],
            },
        ],
    },
    {
        name: $t("l_tel_merge"),
        routerPath: "/admin/tel-unification",
        icon: "phone",
        permissionTag: "__",
        children: [],
    },
    {
        name: $t("l_Join_warehouse"),
        icon: "library_add",
        routerPath: "/admin/order/join-warehouse",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Not_exists") + " (MBatch)",
        icon: "package",
        routerPath: "/admin/order/not-exists",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Unclaimed_goods"),
        icon: "production_quantity_limits",
        routerPath: "/admin/order/unclaimed-goods",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Additional_payment"),
        icon: "request_page",
        routerPath: "/admin/submit-application",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Weight_change_history"),
        icon: "view_stream",
        routerPath: "/admin/order/change-weight",
        expand: false,
        children: [],
    },
    {
        name: $t("l_JPID_change_history"),
        icon: "history",
        routerPath: "/admin/order/change-jpid",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Change_branch"),
        icon: "change_circle",
        routerPath: "/admin/order/change-branch-by-file",
        expand: false,
        children: [],
    },
    {
        name: "Json view",
        icon: "code",
        routerPath: "/admin/supervision/json-view",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Order") + " (oid)",
        icon: "widgets",
        routerPath: "/admin/supervision/order-by-oid",
        expand: false,
        children: [],
    },
    {
        name: "Excel (" + $t("l_Recipient") + ")",
        icon: "how_to_reg",
        routerPath: "/admin/verified-excel",
        expand: false,
        children: [],
    },
    {
        name: "Excel (JPID + телефон)",
        icon: "dual_screen",
        routerPath: "/admin/supervision/phone-by-jpid",
        expand: false,
        children: [],
        openForUsers: ["GZTR", "JP9472", "AKSL", "JP9882", "JP2400299", "JP339209", "JP571690", "JP458515", "JP2085022", "JP342170", "JP2376404", "JP2071926"],
    },
    {
        name: "Track push",
        icon: "playlist_add_circle",
        routerPath: "/admin/debug/track-push",
        expand: false,
        children: [],
    },
    {
        name: "Track",
        icon: "track_changes",
        routerPath: "/admin/debug/track",
        expand: false,
        children: [],
    },
    {
        name: "Ticket",
        icon: "confirmation_number",
        routerPath: "/admin/ticket/list",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Admin"),
        icon: "person",
        routerPath: "/admin/account",
        expand: false,
        children: [],
        isSuper: true,
    },
    {
        name: $t("l_Update_password"),
        icon: "manage_accounts",
        routerPath: "/admin/super/update-all-user-pw",
        expand: false,
        children: [],
        isSuper: true,
    },
]

export default MenuList
